import React from "react";

import { useTranslation } from "utils";

import { useYearLabel } from "pages/app/scenario-analysis/hooks/useYearLabel";
import type { ViewMode } from "pages/app/scenario-analysis/utils/forecast";

type SnapshotHeaderProps = {
  displayYears: number[];
  /** Every year as a dense column (annual, yield) rather than the cumulative snapshot years. */
  isAllYearsLayout: boolean;
  viewMode: ViewMode;
  showTotalCol: boolean;
};

/** Column headers of the comparison table: scenario, one per shown year, the annual total, and the expand column. */
export const SnapshotHeader = ({ displayYears, isAllYearsLayout, viewMode, showTotalCol }: SnapshotHeaderProps) => {
  const { t } = useTranslation("scenarioAnalysis");
  const { formatYearShort, formatYear } = useYearLabel();

  return (
    <thead>
      <tr>
        <th scope="col" className="outcome-comparison-table-head outcome-comparison-table-head-sticky">
          {t("outcomeComparison.column.scenario")}
        </th>
        {displayYears.map((year) => (
          <th key={year} scope="col" className="outcome-comparison-table-head">
            {isAllYearsLayout ? formatYearShort(year) : formatYear(year)}
            {viewMode === "yield" ? <div className="outcome-comparison-table-head-unit">{t("outcomeComparison.unit.yield")}</div> : null}
          </th>
        ))}
        {showTotalCol ? (
          <th scope="col" className="outcome-comparison-table-head outcome-comparison-table-cell--total">
            {t("outcomeComparison.column.total")}
          </th>
        ) : null}
        <th scope="col" className="outcome-comparison-table-head outcome-comparison-table-expand-head" />
      </tr>
    </thead>
  );
};
